// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1v7Of","header":"PatientQuestionnaire_header__1V9ez","info":"PatientQuestionnaire_info__ercgQ"};